export default {
  base: {
    wrapper: {
      position: 'relative',
      overflow: 'visible',
      option: {
        display: 'none'
      },
      variant: 'spark.base.wrapper'
    }
  },
  menu: {
    base: {
      position: 'absolute',
      zIndex: 1,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'grey-100',
      width: ['100%', 356, 608],
      padding: 0,
      listStyle: 'none',
      outline: 'none',
      mt: 8,
      mb: 0,
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)'
    },
    variants: {
      hidden: {
        display: 'none'
      }
    }
  },
  item: {
    base: {
      fontSize: 16,
      lineHeight: '1.5',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      appearance: 'none',
      color: 'grey-100',
      backgroundColor: 'grey-0',
      padding: 16,
      border: 'none',
      width: '100%',
      textAlign: 'left',
      cursor: 'pointer',
      outline: 'none',
      wrapper: {
        display: 'flex',
        listStyle: 'none',
        width: ['100%', 354, 606],
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: 'grey-20',
        ':last-of-type': {
          borderBottom: 'none'
        }
      },
      icon: {
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: 'grey-0',
        borderRadius: '50%',
        width: 20,
        height: 20
      }
    },
    variants: {
      hover: {
        variant: 'spark.element.dropdown.item.base',
        backgroundColor: 'grey-10',
        svg: {
          variant: 'spark.element.dropdown.item.base.icon',
          borderColor: 'grey-100'
        }
      },
      focus: {
        variant: 'spark.element.dropdown.item.base',
        backgroundColor: 'cyan',
        svg: {
          variant: 'spark.element.dropdown.item.variants.hover.svg'
        }
      },
      checked: {
        variant: 'spark.element.dropdown.item.base',
        backgroundColor: 'primary',
        color: 'grey-0'
      },
      disabled: {
        variant: 'spark.element.dropdown.item.base',
        color: 'grey-40'
      }
    }
  }
};